import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

const MenuGreeting = ({ name, email }) => (
  <div>
    <div className="menu-greeting__name">Hello, {name}</div>
    <div className="menu-greeting__email">{email}</div>
  </div>
);

MenuGreeting.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default MenuGreeting;



// WEBPACK FOOTER //
// ./src/common/components/MenuGreeting/index.js